// App.js
import React from 'react';
import { Route, Routes} from 'react-router-dom';
import './App.css';
import CommitteeMembers from './Pages/CommitteeMembers/CommitteeMembers.js';
import Activities from './Pages/ActivitesPage/Activities';
import Login from './Pages/LoginPage/Login.js';
import Register from './Pages/RegistrationPage/Register';
import ForgotPassword from './Pages/LoginPage/ForgotPassword';
import UserProfile from './Pages/UserProfile/UserProfile';
import RegistrationForm from './Pages/FormPage/RegistrationForm.js';
import MainLayout from './layouts/MainLayout';
import { AuthProvider } from './Pages/AuthContext';
import About from './Pages/AboutPage/About.js';
import Contact from './Pages/ContactPage/Contact.js';
import ProtectedRoute from './ProtectedRoute.js';
import Home from './Pages/Home.js';
import RegisterStep1 from "./Pages/RegistrationPage/RegisterStep1.js";
import RegisterStep2 from "./Pages/RegistrationPage/RegisterStep2.js";
import PageNotFound from './Pages/PageNotFound/PageNotFound.js';
import PaymentPage from './Pages/PaymentPage/PaymentPage.js';
import ConfirmationPage from './Pages/ConformationPage/ConformationPage.js';
import CMERequestForm from './Pages/CME_RegistrationPage/CMERegistration/CMERegistration.js';
import UserWaitPage from './Pages/CME_RegistrationPage/UserWaitPage/UserWaitPage.js';
import CMEPaymentPage from './Pages/CME_RegistrationPage/CMEPaymentPage/CMEPaymentPage.js';
import PaymentSuccess from './Pages/CME_RegistrationPage/CMEPaymentSuccess/PaymentSuccess.js';
import ScrollToTop from './components/ScrollToTop/ScrollToTop.js';
import GpconPage from './Pages/GPCON2025/GpconPage.js';
import GpconRegForm from './Pages/GPCON2025/GpconRegForm.js';
import RegistrationSuccess from './Pages/GPCON2025/RegistrationSuccess.js';
function App() {
  return (
    <AuthProvider>
      <ScrollToTop/>
      <Routes>
        
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/CommitteeMembers" element={<CommitteeMembers />} />
          <Route path="/About" element={<About />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/activities/2019" element={<Activities />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
           <Route path="/Register" element={<Register />} /> 
          <Route path="/register/step1" element={<RegisterStep1 />} />
          <Route path="/register/step2" element={<RegisterStep2 />} />
          <Route path="/RegistrationForm" element={<RegistrationForm />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/confirmation" element={<ConfirmationPage />} />
          <Route path='/CMERequest' element={<CMERequestForm/>}/>
          <Route path='/Request/:id' element={<UserWaitPage/>}/>
          <Route path='//Checkout' element={<CMEPaymentPage/>}/>
          <Route path='PaymentSuccess' element={<PaymentSuccess/>}/>
          <Route path="/gpcon2025" element={<GpconPage/>}/>
          <Route path="/Registration-form" element={<GpconRegForm />} />
          <Route path="/registration-success" element={<RegistrationSuccess/>} />
          {/* Protected Routes */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute >
                <UserProfile />
              </ProtectedRoute>
            }
          />
        </Route>

      </Routes>
    </AuthProvider>
  );
}




export default App;
